// +----------------------------------------------------------------------
// | Desc:路径库(路径组合、接口请求、链接跳转等)
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | Desc:跳转到页面
// +----------------------------------------------------------------------
// | Param:param page跳转的页面
// +----------------------------------------------------------------------
Vue.prototype.$go = function (page) {
  this.$router.push(page);
};

// +----------------------------------------------------------------------
// | Desc:跳转到上一页，如果没有上一页默认跳转到首页
// +----------------------------------------------------------------------
// | Param:url 如果没有上一页跳转位置
// | Param:type 跳转方式，默认tabbar
// +----------------------------------------------------------------------
// | Reurn:void;
// +----------------------------------------------------------------------
Vue.prototype.$goBack = function (url, type) {
  // 检查是否可以安全地返回上一页
  if (this.$router && this.$route && this.$router.history.length > 1) {
    // 如果可以，就返回上一页
    this.$router.go(-1);
  } else {
    // 如果无法返回上一页，可以做一些处理，比如提示用户
    this.$msg("无法返回上一页，已经是第一页了");
  }
};

// +----------------------------------------------------------------------
// | Desc:请求接口封装防抖函数
// +----------------------------------------------------------------------
Vue.prototype.$debounce = function (func, wait, that) {
  return function (...args) {
    const context = this;
    clearTimeout(that.timeout);
    that.timeout = setTimeout(() => func.apply(context, args), wait);
  };
};

// +----------------------------------------------------------------------
// | Desc: 请求接口封装
// +----------------------------------------------------------------------

Vue.prototype.$httpsApi = function (https, callbackOK, callbackError) {
  let that = this; //实例的引用
  var type = https.type || "isPagelist"; //获取请求类型，默认为分页列表请求
  var api = https.api || ""; // 获取API接口方法
  var parameter = https.parameter || {}; // 获取请求参数，默认为空对象
  var isLoading = https.isLoading; // 获取加载状态标识，默认为 undefined
  var errorMsg = https.errorMsg || ""; // 获取错误提示信息，默认为空字符串
  var successMsg = https.successMsg || ""; // 获取错误提示信息，默认为空字符串

  //分页
  if (type == "isPagelist") {
    that.selectedRows = [];
    isLoading = isLoading || "isLoadingStr";
  }

  //详情
  if (type == "isRow") {
    isLoading = isLoading || "isLoadingPop";
  }

  //后台
  if (type == "isApi") {
    isLoading = isLoading;
  }

  // 根据加载状态标识显示加载状态
  if (isLoading == "isLoadingStr") {
    that.loading = true;
  }

  if (isLoading == "isLoadingPop") {
    that.$loading(true);
  }

  // 发起 API 请求
  api(parameter).then((res) => {
    // 根据加载状态标识隐藏加载状态
    if (isLoading == "isLoadingStr") {
      that.loading = false;
    }

    if (isLoading == "isLoadingPop") {
      that.$loading(false);
    }

    // 检查响应状态码
    if (res.code == 0) {
      //分页
      if (type == "isPagelist") {
        that.list = res.data;
        that.total = res.count;
      }

      //详情
      if (type == "isRow") {
        that.row = res.data;
      }

      //成功提示
      if (!this.$isblank(successMsg)) {
        this.$msg(successMsg, "success");
      }

      // 成功回调
      callbackOK && callbackOK(res);
    } else {
      // 请求失败
      if (this.$isblank(errorMsg)) {
        this.$msg(res.msg, "error");
      } else {
        this.$msg(errorMsg, "error");
      }

      //失败回调
      callbackError && callbackError(res);
    }
  });
};

// +----------------------------------------------------------------------
// | Desc:图片路径拼接库
// +----------------------------------------------------------------------
Vue.prototype.$httpImg = function (url, isface) {
  var config = this.$configBase();
  if (this.$isblank(url)) {
    if (isface == "isface") {
      return config.img + "/static/noface.png";
    }
    if (isface == "isLogo") {
      return config.img + "/static/logo.png";
    }
    return config.img + "/static/noimg.png";
  }
  if (!url.includes("http")) {
    var url = config.img + url;
  }
  return url;
};

// +----------------------------------------------------------------------
// | Desc:图片路径拼接库
// +----------------------------------------------------------------------
Vue.prototype.$httpFile = function (url, isface) {
  var config = this.$configBase();
  if (this.$isblank(url)) {
    return "";
  }
  if (!url.includes("http") && !url.includes("https")) {
    var url = config.api + url;
  }
  return url;
};

// +----------------------------------------------------------------------
// | Desc:获取url参数
// +----------------------------------------------------------------------
Vue.prototype.$getUrlParams = function (param) {
  const urlParams = new URLSearchParams(window.location.search);
  var res = urlParams.get(param);
  if (res) {
    return res;
  } else {
    return "";
  }
};
